module.exports = __webpack_public_path__ + "static/media/piper-messages-wo-bg.740e211d.svg";